import CustomModal from "../custom-modal";

const FullImageModal = ({ id, image, size, ...otherProps }) => {
  return (
    <CustomModal id={`full-image-modal_${id}`} hasCloseButton size={size ?? "xl"} {...otherProps}>
      {image && <img src={image} class="w-100" alt={id} />}
    </CustomModal>
  );
};

export default FullImageModal;
